import { hostFactory as hostInstance } from "../factory";

const getCompanyById = id => hostInstance.get(`/api/companies/${id}`);

const getCompanies = () => hostInstance.get("/api/companies/");

const getOperational = (id, type) =>
  hostInstance.get(`/api/companies/${id}/${type}`);

const updateCompany = updatedCompany =>
  hostInstance.put(`/api/companies/${updatedCompany.id}`, updatedCompany);

const deleteCompany = id => hostInstance.delete(`/api/companies/${id}`);

export { getOperational, getCompanyById, deleteCompany, updateCompany };

export default getCompanies;
